import PropTypes from 'prop-types';
import React from 'react';
import { Drawer } from '@unite-us/app-components';
import { noop } from 'lodash';
import NetworkGroupDetails from 'src/components/Groups/GroupDetails/NetworkGroupDetails';
import { TOP_NAVIGATION_HEIGHT } from 'src/components/Navigation/constants';
import '../stylesheets/networkGroupsDrawer.scss';

const NetworkGroupsDrawer = ({
  center,
  groupPrograms,
  network,
  onClose,
  open,
  providerLocations,
  providerServices,
  selectedProvider,
  selectedServiceIds,
  ctaBtnRef,
}) => (
  <Drawer
    className="network-groups-drawer"
    onClose={onClose}
    open={open}
    secondary
    topOffset={TOP_NAVIGATION_HEIGHT}
    width="500px"
    ctaBtnRef={ctaBtnRef}
  >
    <NetworkGroupDetails
      center={center}
      selectedProvider={selectedProvider}
      programs={groupPrograms}
      selectedServiceIds={selectedServiceIds}
      network={network}
      providerLocations={providerLocations}
      providerServices={providerServices}
    />
  </Drawer>
);

NetworkGroupsDrawer.propTypes = {
  center: PropTypes.object.isRequired,
  groupPrograms: PropTypes.array,
  network: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  selectedServiceIds: PropTypes.arrayOf(
    PropTypes.string.isRequired,
  ).isRequired,
  providerLocations: PropTypes.array,
  providerServices: PropTypes.array,
  selectedProvider: PropTypes.object.isRequired,
  ctaBtnRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};

NetworkGroupsDrawer.defaultProps = {
  groupPrograms: [],
  onClose: noop,
  open: false,
  network: {},
  providerLocations: [],
  providerServices: [],
};

export default NetworkGroupsDrawer;
